module.exports = __webpack_public_path__ + "static/salawu-b1d14feb3bdad4bf8091a2cb151dbf4d.jpg";